module.exports = __webpack_public_path__ + "static/parade-2020-house51-303daeb2962938335f4dd97ef6afc185.jpg";